import { CopyOutlined } from '@ant-design/icons';
import { Button, Col, Form, Mentions, message, Modal, Row, Tooltip } from 'antd';
import React, { useEffect, useState } from "react";
import {
    injectIntl
} from "react-intl";
import { typeOf } from 'react-is';
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import {
    actionAcceptTransasctionWithdrawUSDT,
    actionCancelTransasctionWithdrawMoney,
    actionCancelTransasctionWithdrawUSDT,
    actionConfrimTransasctionWithdrawMoney
} from '../../../redux/transaction/actions';
import {
    Card,
    CardBody,
    CardHeader
} from "../../../_metronic/_partials/controls";
import { formatCoinID, formatMoney, formatMoneyCoin } from '../../lib/common';
import moment from 'moment';


const formRef = React.createRef()
function CreateUpdateWithdrawMoney(props) {
    const dispatch = useDispatch();
    const { intl } = props
    const { visibleModal, onCloseModal, recordModal, setRecordModal, filterModal } = props
    const [visible, setVisible] = useState(visibleModal)
    const [modalCancel, setModalCancel] = useState(false)
    const [modalConfrim, setModalConfrim] = useState(false)
    const [modalConfrimNoEpay, setModalConfrimNoEpay] = useState(false)
    const renderType = (key) => {
        switch (key) {
            case "by_order":
                return "Phí Mua Hàng"
            case "deposit":
                return "Nạp Tiền"
            case "swap_gold_money":
                return "Bán Vàng"
            case "swap_money_gold":
                return "Mua Vàng"
            case "withdraw_gold":
                return "Phí Rút Vàng"
            default:
                return ""
        }
    }
    useEffect(() => {

    }, [dispatch])

    // const { dataWithdrawMoneyTransaction } = useSelector(state => ({
    //     dataWithdrawMoneyTransaction: state.transactionReducer.dataWithdrawMoneyTransaction
    // }), shallowEqual)
    const renderStatus = (record) => {
        let status = record?.status;
        if (status == 0 && record?.pending_epay) {
            return 'Epay đang xử lý'
        }
        switch (status) {
            case 0: {
                return "Chờ duyệt"
            }
            case 1: {
                return "Thành công"
            }
            case 2: {
                return "Đang xử lý"
            }
            case -1: {
                return "Ngừng giao dịch"
            }
            default:
                break;
        }
    }

    const [form] = Form.useForm();
    const onFinishCancel = async () => {
        try {
            await form.validateFields();
            const { reason } = form.getFieldValue();
            let res = await dispatch(actionCancelTransasctionWithdrawUSDT({ dataPush: { id: recordModal?.id, reason, "symbol": "USDT" }, filterModal }))
            if (res.code === 200) {
                setModalCancel(false)
                onCloseModal(false)
                setVisible(false)
                message.error("Đã hủy giao dịch thành công");
            }

        } catch (errInfo) {
            return message.errInfo
        }
    };
    const onFinishConfrim = async () => {
        try {
            const { reason } = form.getFieldValue();
            let res = await dispatch(actionAcceptTransasctionWithdrawUSDT({ dataPush: { id: recordModal?.id, reason, "symbol": "USDT" }, filterModal }))
            if (res.code === 200) {
                setModalConfrim(false)
                onCloseModal(false)
                setVisible(false)
                message.success("Đã duyệt giao dịch thành công");
            }
        } catch (errInfo) {
            return message.errInfo
        }
    };
    const onFinishConfrimNoEpay = async () => {
        try {
            const { reason } = form.getFieldValue();
            let res = await dispatch(actionAcceptTransasctionWithdrawUSDT({ dataPush: { id: recordModal?.id, reason, "symbol": "USDT" }, filterModal }))
            if (res.code === 200) {
                setModalConfrim(false)
                onCloseModal(false)
                setVisible(false)
                message.success("Đã duyệt giao dịch thành công");
            }
        } catch (errInfo) {
            return message.errInfo
        }
    };
    let reason = '';
    try {
        if (recordModal?.metadata && typeOf(recordModal?.metadata) === 'string') {
            const dataReson = JSON.parse(recordModal?.metadata)
            reason = dataReson.reason
        } else {
            reason = recordModal?.metadata.reason
        }
    } catch (error) {
        console.log(error);
    }

    const onCopy = (value) => {
        message.success('Sao chép thành công!')
        navigator.clipboard.writeText(value)
    }

    const renderNameNetwork = (network) => {
        switch(network) {
            case 'ton':
                return 'TON'
            case 'tron': 
                return 'Tron'
            case 'polygon':
                return 'Polygon'
            case 'bsc':
                return 'BSC'
        }
    }
    return (
        <Modal visible={visibleModal} width={600}
            bodyStyle={{ position: "relative" }} onCancel={onCloseModal} style={{ top: 0 }}
            centered={true}
            footer={recordModal?.status === 1 || recordModal?.status === -1 || recordModal?.status === 2 ?
                (<div>
                    {recordModal?.status === 0 ? <><Button type="primary" danger onClick={() => setModalCancel(true)}>Hủy</Button>
                        {/* <Button type="primary" onClick={() => setModalConfrim(true)} > Thực hiện chuyển khoản qua Epay </Button> */}
                        <Button type="primary" onClick={() => setModalConfrimNoEpay(true)} >Xác nhận </Button></> : <></>}
                </div>)
                :
                recordModal?.status === 0 ?
                    (<div>
                        <Button type="primary" danger onClick={() => setModalCancel(true)}>Hủy</Button>
                        <Button type="primary" onClick={() => setModalConfrim(true)}>Duyệt</Button>
                    </div>)
                    : null
            }
        >
            <Card>
                <CardHeader title={`Trạng thái: ${renderStatus(recordModal)}`} >
                </CardHeader>
                <CardBody>
                    <Col span={24}>
                        <div style={{ fontSize: 18 }} className="customLabel">Thông tin chi tiết giao dịch</div>
                        <Row style={{ marginTop: "20px" }}>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Khách hàng:</lable>
                                <div>{recordModal?.user?.fullname || "--"}</div>
                            </Col>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Email:</lable>
                                <div>{recordModal?.user?.email || "--"}</div>
                            </Col>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Số điện thoại:</lable>
                                <div>{recordModal?.user?.mobile || "--"}</div>
                            </Col>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Thời gian giao dịch:</lable>
                                <div>
                                    <div style={{ float: 'left', marginRight: '10px' }}>{moment(recordModal?.createdAt).format('DD/MM/YYYY HH:mm:ss')}</div>
                                </div>
                            </Col>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Tên mạng lưới:</lable>
                                <div>{renderNameNetwork(recordModal?.network) || "--"}</div>
                            </Col>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Mã giao dịch:</lable>
                                <div>
                                    <div style={{ float: 'left', marginRight: '10px' }}>{recordModal?.transaction_id || "--"}</div>
                                    <Tooltip title="Copy">
                                        <Button disabled={recordModal?.transaction_id !== '' ? false : true} icon={<CopyOutlined />} onClick={() => onCopy(recordModal?.transaction_id)} />
                                    </Tooltip>
                                </div>
                            </Col>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Số tiền:</lable>
                                <div>
                                    <div style={{ float: 'left', marginRight: '10px' }}>{formatCoinID(Math.abs(Number(recordModal?.amount)), 4) || "--"}</div>
                                </div>
                            </Col>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Phí giao dịch:</lable>
                                <div>
                                    <div style={{ float: 'left', marginRight: '10px' }}>{recordModal?.transaction?.fee ? formatCoinID(Math.abs(Number(recordModal?.transaction?.fee)), 4) : "0 USDT"}</div>
                                </div>
                            </Col>
                        </Row>
                        {/* <Row>

                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Người xác nhận:</lable>
                                <div>
                                    {recordModal?.user_confirm_withdraw?.fullname || "--"}
                                </div>
                            </Col>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Lý do:</lable>
                                <div>{reason || "--"}</div>
                            </Col>
                        </Row> */}
                    </Col>

                    <Modal visible={modalCancel}
                        closable={() => setModalCancel(false)}
                        onCancel={() => setModalCancel(false)}
                        onOk={onFinishCancel}
                    >
                        <div style={{ fontWeight: 1200, fontSize: 18 }} className="customLabel">Lý do hủy giao dịch</div>
                        <Form form={form} layout="horizontal" >
                            <Form.Item
                                name="reason"
                                labelCol={{ span: 6 }}
                                wrapperCol={{ span: 16, }}
                                rules={[
                                    {
                                        validator: (_, value) => {
                                            if (!value || value.trim() === "") {
                                                return Promise.reject("Chưa nhập lý do hủy!")
                                            } else {
                                                return Promise.resolve()
                                            }
                                        }
                                    }
                                ]}
                            >
                                <Mentions rows={3} placeholder="Nhập lý do hủy giao dịch">
                                </Mentions>
                            </Form.Item>
                        </Form>
                    </Modal>
                    <Modal visible={modalConfrim}
                        closable={() => setModalConfrim(false)}
                        onCancel={() => setModalConfrim(false)}
                        onOk={onFinishConfrim}
                    >
                        <div style={{ fontWeight: 1200, fontSize: 18 }} className="customLabel">Lý do duyệt</div>
                        <Form form={form} layout="horizontal">
                            <Form.Item
                                name="reason"
                                labelCol={{ span: 6 }}
                                wrapperCol={{ span: 16, }}
                                rules={[{ required: true, },]}
                            >
                                <Mentions rows={3} placeholder="Nhập lý do duyệt">
                                </Mentions>
                            </Form.Item>
                        </Form>
                    </Modal>
                    <Modal visible={modalConfrimNoEpay}
                        closable={() => setModalConfrimNoEpay(false)}
                        onCancel={() => setModalConfrimNoEpay(false)}
                        onOk={onFinishConfrimNoEpay}
                    >
                        <div style={{ fontWeight: 1200, fontSize: 18 }} className="customLabel">Lý do duyệt</div>
                        <Form form={form} layout="horizontal">
                            <Form.Item
                                name="reason"
                                labelCol={{ span: 6 }}
                                wrapperCol={{ span: 16, }}
                                rules={[{ required: true, },]}
                            >
                                <Mentions rows={3} placeholder="Nhập lý do duyệt">
                                </Mentions>
                            </Form.Item>
                        </Form>
                    </Modal>
                </CardBody>
            </Card>
        </Modal >

    );
}

export default injectIntl(withRouter(CreateUpdateWithdrawMoney));
